export default {
  order: (state) => state.order,
  loading: (state) => state.loading,
  readyStatusModalIsOpen: (state) => state.readyStatusModalIsOpen,
}
